/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { DeleteProjectsProjectidOptions, DeleteProjectsProjectidResponses } from '../types/DeleteProjectsProjectid'
import { client, withUnwrap } from '../.kubb/client'

/**
 * {@link /projects/:projectId}
 */
export function deleteProjectsProjectid<ThrowOnError extends boolean = true>(options: Options<DeleteProjectsProjectidOptions, ThrowOnError>): Unwrappable<RequestResult<DeleteProjectsProjectidResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(request({ method: 'DELETE', url: '/projects/{projectId}', security: [{ type: 'http', scheme: 'bearer' }], responseType: 'text', ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<DeleteProjectsProjectidResponses, ThrowOnError>>)
}
